import React, { useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { Fragment } from "react";
import { ReactComponent as MenuSVG } from "./menu.svg";
import { AuthContext } from "../../../../auth-context";
import { DashboardContext } from '../../dashboard-context'
import { ThemeContext } from 'styled-components'
import AvatarLogo from '../../../../images/theme/avatar/logo-horizontal-white.png';
import FBBCLogo from '../../../../images/theme/fbbc/fbbc-logo.png'
import { Dashboard, Pageview, Kitchen, People, Schedule, GroupWork, Chat, Folder, FolderShared, Receipt, HelpOutline, ExitToApp, Settings, Subject, CalendarToday, FormatListNumbered } from '@material-ui/icons';

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 0px;
  height: 100vh;
  overflow: auto;
  width: 200px;
  z-index: 99;

  @media (max-width: 900px) {
    display: none;
  }
`;

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: 32px;
  padding: 0px 8px;
`;

const Header = styled.div`
  background: ${(props) => props.theme.color.dark};
`;

const Logo = styled.img`
  height: 36px;
  max-width: 170px;
  margin: 0px 18px;
`;

const HeaderLink = styled(NavLink)`
  border-bottom: 2px solid transparent;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: ${(props) => props.theme.font.primary};
  font-size: .9rem;
  font-weight: 400;
  padding: 8px 10px;
  margin: 2px 0px;
  width: 100%;
  text-decoration: none;

  svg {
    font-size: 1.25rem;
    margin-right: 8px;
  }

  &.active {
    /* border-bottom: 2px solid ${(props) => props.theme.color.secondary}; */
    color: ${(props) => props.theme.color.secondary} !important;
  }

  &:hover {
    background: ${(props) => props.theme.color.highlight}
    /* color: ${(props) => props.theme.color.secondary}; */
  }
`;

const Category = styled.p`
  color: #9c9c9c;
  font-size: .9rem;
  font-weight: 400;
  padding: 16px 0px 0px 12px;
`;

const MessageLink = styled.div`
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: ${(props) => props.theme.font.primary};
  font-size: .9rem;
  font-weight: 400;
  padding: 8px 10px;
  position: relative;
  margin: 2px 0px;
  width: 100%;
  text-decoration: none;
  transition: 0.2s ease all;

  
  svg {
    font-size: 1.25rem;
    margin-right: 8px;
  }

  >div {
    background: red;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    height: 16px;
    width: 16px;
    top: 2px;
    right: 4px;

    p {
      color: #FFF;
      font-size: .7rem;
      font-weight: bold;
    }
  }

  &.active {
    /* border-bottom: 2px solid ${(props) => props.theme.color.secondary}; */
    color: ${(props) => props.theme.color.secondary} !important;
  }

  &:hover {
    background: ${(props) => props.theme.color.highlight}
    /* color: ${(props) => props.theme.color.secondary}; */
  }
`;

const ExpandableMenu = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ExpandableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 10px;
  cursor: pointer;
  color: #fff;
  font-family: ${(props) => props.theme.font.primary};
  font-size: .9rem;
  font-weight: 400;
  border-radius: 6px;
  margin: 2px 0px;

  svg {
    font-size: 1.25rem;
    margin-right: 8px;
  }

  &:hover {
    background: ${(props) => props.theme.color.highlight};
  }
`;

const SubMenu = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  max-height: ${props => props.isOpen ? '200px' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease-out;
`;

const SubMenuItem = styled(NavLink)`
  color: #fff;
  padding: 8px 10px;
  text-decoration: none;
  font-size: .9rem;
  border-radius: 6px;
  margin: 2px 0px;

  &:hover {
    background: ${(props) => props.theme.color.highlight};
  }

  &.active {
    color: ${(props) => props.theme.color.secondary} !important;
  }
`;

const MobileHeaderWrapper = styled.div`
  align-items: center;
  background: ${(props) => props.theme.color.dark};
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  padding: 4px 8px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 550;
  @media (min-width: 901px) {
    display: none;
  }

  button {
    background: ${(props) => props.theme.color.highlight};
    border: none;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
    transition: 0.3s ease background;

    svg {
      height: auto;
      width: 33px;
      fill: ${(props) => props.theme.color.secondary};
    }

    &:focus {
      outline: none;
    }
  }

  > svg {
    height: auto;
    width: 130px;
    position: absolute;
    left: 50%;
    top: 54%;
    transform: translateX(-50%) translateY(-50%);
  }
`;

const MobileMenu = styled.div`
  background: ${(props) => props.theme.color.dark};
  border-top: 1px solid #474747;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
  display: block;
  position: fixed;
  top: 55px;
  left: 0px;
  opacity: ${(props) => (props.showMenu ? "1" : "0")};
  padding: 0px 0px 16px 0px;
  transform: ${(props) =>
    props.showMenu ? "translateY(-0%)" : "translateY(-150%)"};
  transition: 0.3s ease-out all;
  height: calc(100vh - 55px);
  overflow: auto;
  width: 100%;
  z-index: 500;
  @media (min-width: 901px) {
    display: none;
  }
`;

const mapLogos = {
  "AVATAR": AvatarLogo,
  "FBBC": FBBCLogo,
}

const Sidebar = (props) => {
  const theme = useContext(ThemeContext)
  const [showMenu, setShowMenu] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const { showMessages, setShowMessages } = React.useContext(DashboardContext);

  return (
    <Fragment>
      <Header>
        <HeaderContent>
          <Logo src={mapLogos[theme.name]} alt="logo" />
          <LinksContainer>
            <Category>Clients</Category>
            <HeaderLink to="/dashboard/overview"><Dashboard /> Overview</HeaderLink>
            {(!!user.messaging) &&
              <MessageLink onClick={() => setShowMessages(!showMessages)}>
                <Chat />
                Messages
                {(props.unreadChannels > 0) && 
                  <div>
                    <p>{props.unreadChannels}</p>
                  </div>
                }
              </MessageLink>
            }
            <HeaderLink to="/dashboard/templates"><Kitchen /> Meal Planning</HeaderLink>
            <HeaderLink to="/dashboard/weekly"><CalendarToday /> Weekly Summary</HeaderLink>
            {(user.role_id === 1 || user.role_id === 2) && 
              <Category>Admin Panel</Category>
            }
            {(user.role_id === 1 || user.role_id === 2) && 
              <HeaderLink to="/dashboard/accounts"><Pageview /> Manage Clients</HeaderLink>
            }
            {(user.role_id === 1 || user.role_id === 2) && 
              <HeaderLink to="/dashboard/groups"><People /> Groups</HeaderLink>
            }
            {(user.role_id === 1 || user.role_id === 2) && theme.name === 'AVATAR' &&
              <HeaderLink to="/dashboard/campaigns"><Schedule /> Campaigns</HeaderLink>
            }
            {/* Toggle only matters for FBBC locations */}
            {(user.role_id === 1 || user.role_id === 2) && (theme.name === 'AVATAR' || (theme.name === 'FBBC' && user.settings?.checkin_form_allowed === true)) &&
              <HeaderLink to="/dashboard/forms/view"><FormatListNumbered /> Check-in Forms</HeaderLink>
            }
            {(user.role_id === 1 || user.role_id === 2) && theme.name === 'FBBC' &&
              <HeaderLink to="/dashboard/hq-challenges"><GroupWork /> HQ Challenges</HeaderLink>
            }
            {(user.role_id === 1 || user.role_id === 2) && 
              <HeaderLink to="/dashboard/team"><FolderShared /> Team</HeaderLink>
            }
            {user.role_id === 1 &&
              <HeaderLink to="/dashboard/billing"><Receipt /> Billing</HeaderLink>
            }
            <Category>Account</Category>
            <HeaderLink to="/dashboard/profile"><Settings /> My Profile</HeaderLink>
            <HeaderLink to="/dashboard/support"><HelpOutline /> Support</HeaderLink>
            {theme.name === 'AVATAR' &&
              <ExpandableMenu>
              <ExpandableHeader onClick={() => setIsResourcesOpen(!isResourcesOpen)}>
                <Folder /> Resources
              </ExpandableHeader>
              <SubMenu isOpen={isResourcesOpen}>
                <SubMenuItem to="/dashboard/resources">Documents</SubMenuItem>
                <SubMenuItem to="/dashboard/videos">Videos</SubMenuItem>
              </SubMenu>
            </ExpandableMenu>
            }
            {theme.name === 'FBBC' &&
              <HeaderLink to="/dashboard/videos"><Folder />  Resources</HeaderLink>
            }
            
            <HeaderLink to="/dashboard/terms"><Subject /> Terms</HeaderLink>
            <HeaderLink exact to="/" onClick={logout}>
              <ExitToApp />
              Logout
            </HeaderLink>
          </LinksContainer>
        </HeaderContent>
      </Header>

      <MobileHeaderWrapper showMenu={showMenu}>
        <button aria-label="Open Menu" onClick={() => setShowMenu(!showMenu)}>
          <MenuSVG />
        </button>
      </MobileHeaderWrapper>

      <MobileMenu showMenu={showMenu}>
        {/* <Logo src={mapLogos[theme.name]} alt="logo" /> */}
          <LinksContainer style={{marginTop: 0}}>
            <Category>Clients</Category>
            <HeaderLink to="/dashboard/overview" onClick={() => setShowMenu(false)}><Dashboard /> Overview</HeaderLink>
            {(!!user.messaging) &&
              <MessageLink onClick={() => {setShowMessages(!showMessages); setShowMenu(false);}}>
                <Chat />
                Messages
                {(props.unreadChannels > 0) && 
                  <div>
                    <p>{props.unreadChannels}</p>
                  </div>
                }
              </MessageLink>
            }
            <HeaderLink to="/dashboard/templates" onClick={() => setShowMenu(false)}><Kitchen /> Meal Planning</HeaderLink>
            <HeaderLink to="/dashboard/weekly" onClick={() => setShowMenu(false)}><CalendarToday /> Weekly Summary</HeaderLink>
            {(user.role_id === 1 || user.role_id === 2) && 
              <Category>Admin Panel</Category>
            }
            {(user.role_id === 1 || user.role_id === 2) && 
              <HeaderLink to="/dashboard/accounts" onClick={() => setShowMenu(false)}><Pageview /> Manage Clients</HeaderLink>
            }
            {(user.role_id === 1 || user.role_id === 2) && 
              <HeaderLink to="/dashboard/groups" onClick={() => setShowMenu(false)}><People /> Groups</HeaderLink>
            }
            {(user.role_id === 1 || user.role_id === 2) && theme.name === 'AVATAR' &&
              <HeaderLink to="/dashboard/campaigns" onClick={() => setShowMenu(false)}><Schedule /> Campaigns</HeaderLink>
            }
            {(user.role_id === 1 || user.role_id === 2) && (theme.name === 'AVATAR' || (theme.name === 'FBBC' && user.settings?.checkin_form_allowed === true)) &&
              <HeaderLink to="/dashboard/forms/view" onClick={() => setShowMenu(false)}><FormatListNumbered /> Check-in Forms</HeaderLink>
            }
            {(user.role_id === 1 || user.role_id === 2) && theme.name === 'FBBC' &&
              <HeaderLink to="/dashboard/hq-challenges" onClick={() => setShowMenu(false)}><GroupWork /> HQ Challenges</HeaderLink>
            }
            {(user.role_id === 1 || user.role_id === 2) && 
              <HeaderLink to="/dashboard/team" onClick={() => setShowMenu(false)}><FolderShared /> Team</HeaderLink>
            }
            {user.role_id === 1 &&
              <HeaderLink to="/dashboard/billing" onClick={() => setShowMenu(false)}><Receipt /> Billing</HeaderLink>
            }
            <Category>Account</Category>
            <HeaderLink to="/dashboard/profile" onClick={() => setShowMenu(false)}><Settings /> My Profile</HeaderLink>
            <HeaderLink to="/dashboard/support" onClick={() => setShowMenu(false)}><HelpOutline /> Support</HeaderLink>
            <ExpandableMenu>
              <ExpandableHeader onClick={() => {setIsResourcesOpen(!isResourcesOpen); setShowMenu(false);}}>
                <Folder /> Resources
              </ExpandableHeader>
              <SubMenu isOpen={isResourcesOpen}>
                <SubMenuItem to="/dashboard/resources" onClick={() => setShowMenu(false)}>Resources</SubMenuItem>
                <SubMenuItem to="/dashboard/videos" onClick={() => setShowMenu(false)}>Videos</SubMenuItem>
              </SubMenu>
            </ExpandableMenu>
            <HeaderLink to="/dashboard/terms" onClick={() => setShowMenu(false)}><Subject /> Terms</HeaderLink>
            <HeaderLink exact to="/" onClick={logout}>
              <ExitToApp />
              Logout
            </HeaderLink>
          </LinksContainer>
      </MobileMenu>
    </Fragment>
  );
};

export default Sidebar;
